import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { madisonWiConfig } from "./data";

export default function MadisonWIPage() {
  return <CityPageTemplate config={madisonWiConfig} />;
}